import AppState from '../state';

export const getFullName = (state: AppState) => {
  return state.user.profile?.fullName || '';
};

export const getEmail = (state: AppState) => {
  return state.user.profile?.email;
};

export const getTelephone = (state: AppState) => {
  return state.user.profile?.telephone;
};
